import "./App.css";
import Burger from "./Components/Burger.js";
import Header from "./Components/Header.js";
import Footer from "./Components/Footer.js";

function App() {
  return (
    <div className="App">
      <div classname="container">
        <Header />
        <Burger />
        <Footer />
      </div>
    </div>
  );
}

export default App;
